// extracted by mini-css-extract-plugin
module.exports = {"text":"tooltip_text__SYUVD","tooltip":"tooltip_tooltip__UtAId","hidden":"tooltip_hidden__7LiBC"};